import { render, staticRenderFns } from "./InheritedImageHint.vue?vue&type=template&id=9ebfc188&scoped=true&"
import script from "./InheritedImageHint.vue?vue&type=script&lang=js&"
export * from "./InheritedImageHint.vue?vue&type=script&lang=js&"
import style0 from "./InheritedImageHint.vue?vue&type=style&index=0&id=9ebfc188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebfc188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
